import { type JSX } from "react";

import { Trans } from "@lingui/react";
import { Loader } from "@mobsuccess-devops/react-ui/Loader";

// The default pending component (PendingPage) says "Chargement des
// informations du compte", which reads as an account page flashing by while
// the app is only redirecting the user: use a neutral loading message instead.
export function RootPending(): JSX.Element {
  return (
    <Loader.Block variant="transparent">
      <Loader.Ellipsis />
      <Loader.Description>
        <Trans id="root.pending-loader" />
      </Loader.Description>
    </Loader.Block>
  );
}
